
import Vue from "vue";
import {SaleRowService} from "@/services";

export default Vue.extend({
	data() {
		return {
			qty: 0,
			date: new Date(),
			creating: false
		};
	},
	props: {
		selectedItems: {
			type: Array as () => any[],
			required: false,
			default: () => []
		},
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async setAndSaveDeliveryDate(){
			if (this.creating) return;
			this.creating = true;
			try{
				let response = await SaleRowService.markAsDelivered(this.selectedItems,0,this.date);
				if (response.undeliverableCount > 0) {
					this.$wf.notify(this.$ctc("sale-rows-set-to-undelivered", response.undeliverableCount), "info", 3000, "info-circle");
				}
				this.$wf.notify(this.$ctc("rows-changed-count", response.changedRows), "success", 3000, "check");
				this.$emit("finished");
				this.$emit("close");
			}catch(err){

			}finally {
				this.creating = false;
			}
		},
	},
	mounted() {
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
